import { FunctionComponent } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { Stack } from "@altimateai/lego";

const PurposeSection: FunctionComponent<{
  purpose: string;
}> = ({ purpose }) => {
  return (
    <div className={classNames(styles.card, "purpose-section")}>
      <Stack direction="column" gap="sm">
        <Stack direction="column" gap="xs">
          <div className="fs-5 fw-semibold">Description</div>
          <div className={classNames(styles.column_card)}>
            <div className="font-normal fs-xxs">{purpose}</div>
          </div>
        </Stack>
      </Stack>
    </div>
  );
};

export default PurposeSection;
